/* Batida B2B blog "Za ladą" - review mode for the team (4.10, Aleksandra's mock-up Batida_podglad_B2B_blog.html).
   Before real articles exist, the team can see the design filled with the mock-up's 7 sample posts
   (assets/batida-b2b-blog-sample.json):
     /blogs/za-lada?podglad=blog            sample list (chips filter with &temat=<key>)
     /blogs/za-lada?podglad=blog&wpis=1     sample article (also on a real article page with ?podglad=blog)
   Only on an unpublished theme (preview link) - the same rule as `previewable` in assets/batida-b2b-views.js. It never
   runs on the published theme, so visitors never see sample posts. Without ?podglad=blog the script does nothing.
   The markup mirrors snippets/batida-b2b-blog-card.liquid and sections/batida-b2b-article.liquid - keep them in step.
   UI texts come from the page (snippets/batida-b2b-blog-i18n.liquid, locale batida.b2b_blog). */
(function () {
  if (window.__bzlBlog) return;
  window.__bzlBlog = true;
  // 4.10 (Aleksandra): no right-click menu / dragging on the blog photos (list, article, body) - like the B2B gallery.
  // Deters casual copying only; runs on the live theme too (before the review-mode exit below).
  function bzlImg(e) { var el = e.target; return el && el.tagName === 'IMG' && el.closest && el.closest('[class*="bzl-"]'); }
  document.addEventListener('contextmenu', function (e) { if (bzlImg(e)) e.preventDefault(); });
  document.addEventListener('dragstart', function (e) { if (bzlImg(e)) e.preventDefault(); });
  var themeRole = (window.Shopify && Shopify.theme && Shopify.theme.role) || '';
  var previewable = themeRole !== 'main' || /shopifypreview\.com$/.test(location.hostname);
  var params = new URLSearchParams(location.search);
  if (!previewable || params.get('podglad') !== 'blog') return;

  var root = document.querySelector('[data-bzl-root]');
  if (!root) return;

  var T = {};
  try {
    var i18nEl = document.querySelector('script[data-bzl-i18n]');
    if (i18nEl) T = JSON.parse(i18nEl.textContent) || {};
  } catch (e) { T = {}; }
  /* Polish fallbacks (review mode is for the Polish team) */
  var FB = {
    all: 'Wszystkie', filter_label: 'Tematy', reading: '[n] min czytania', read_more: 'Czytaj', crumb_label: 'Ścieżka',
    tag_pairing: 'Pairing', tag_biznes: 'Biznes', tag_witryna: 'Witryna', tag_za_lada: 'Za ladą', tag_sezon: 'Sezon', tag_klienci: 'Klienci',
    calc_eyebrow: 'Kalkulator marży', calc_title: 'Ile zarobisz na jednej porcji?', calc_text: 'Sprawdź przy każdym deserze w katalogu.',
    calc_cta: 'Otwórz katalog', desserts_title: 'Desery z tekstu', cta_title: 'Nie wiesz, co zamówić?',
    cta_text: 'Odpowiedz na 6 pytań - ułożymy Ci witrynę pod Twoją kawę.', cta_button: 'Dopasuj witrynę', next_title: 'Czytaj dalej',
    preview_banner: 'PODGLĄD - przykładowe wpisy', preview_off: 'wyłącz podgląd'
  };
  /* texts from the locale files are already HTML-escaped by Shopify's t filter, so they go into innerHTML as they are */
  function t(k) { return typeof T[k] === 'string' && T[k] ? T[k] : FB[k] || ''; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var TOPICS = ['pairing', 'biznes', 'witryna', 'za_lada', 'sezon', 'klienci'];
  var blogUrl = root.getAttribute('data-bzl-blog-url') || location.pathname;
  var blogTitle = root.getAttribute('data-bzl-blog-title') || t('tag_za_lada');
  var catalogUrl = root.getAttribute('data-bzl-catalog') || '/collections/b2b-produkty';
  var view = root.getAttribute('data-bzl-view');

  function tagLabel(key) { return TOPICS.indexOf(key) > -1 ? t('tag_' + key) : esc(key); }
  function reading(n) { return t('reading').split('[n]').join(String(n || 1)); }
  function listUrl(topic) { return blogUrl + '?podglad=blog' + (topic ? '&temat=' + encodeURIComponent(topic) : ''); }
  function postUrl(p) { return blogUrl + '?podglad=blog&wpis=' + p.id; }
  function part(name) { return root.querySelector('[data-bzl-part="' + name + '"]'); }

  function card(p, o) {
    o = o || {};
    var lv = o.level || 'h2', label = tagLabel(p.tag);
    return '<a class="bzl-card' + (o.big ? ' bzl-card--big' : '') + '" href="' + esc(postUrl(p)) + '">' +
      '<div class="bzl-card__img bzl-tone--' + esc(p.tag) + '"><span class="bzl-ph" aria-hidden="true">' + label + '</span></div>' +
      '<div class="bzl-card__bd">' +
        '<div class="bzl-meta"><span class="bzl-tag">' + label + '</span><span>' + reading(p.minutes) + '</span></div>' +
        '<' + lv + ' class="bzl-card__title">' + esc(p.title) + '</' + lv + '>' +
        (p.excerpt ? '<p class="bzl-card__excerpt">' + esc(p.excerpt) + '</p>' : '') +
        '<span class="bzl-card__more">' + t('read_more') + ' <span aria-hidden="true">→</span></span>' +
      '</div></a>';
  }

  function banner() {
    if (root.querySelector('.bzl-review')) return;
    var div = document.createElement('div');
    div.className = 'bzl-review';
    div.setAttribute('role', 'note');
    div.innerHTML = '<b>' + t('preview_banner') + '</b><a href="' + esc(blogUrl) + '">' + t('preview_off') + '</a>';
    root.insertBefore(div, root.firstChild);
  }

  function renderList(posts) {
    var topic = params.get('temat') || '';
    if (TOPICS.indexOf(topic) < 0) topic = '';
    var chipsNav = part('chips');
    if (chipsNav) {
      var used = TOPICS.filter(function (k) { return posts.some(function (p) { return p.tag === k; }); });
      var html = '<li><a class="bzl-chip' + (topic ? '' : ' is-on') + '" href="' + esc(listUrl('')) + '"' + (topic ? '' : ' aria-current="page"') + '>' + t('all') + '</a></li>';
      used.forEach(function (k) {
        var on = k === topic;
        html += '<li><a class="bzl-chip' + (on ? ' is-on' : '') + '" href="' + esc(listUrl(k)) + '"' + (on ? ' aria-current="page"' : '') + '>' + tagLabel(k) + '</a></li>';
      });
      var ul = chipsNav.querySelector('.bzl-chips');
      if (ul) ul.innerHTML = html;
      chipsNav.hidden = false;
    }
    var list = part('list');
    if (!list) return;
    var shown = posts.filter(function (p) { return !topic || p.tag === topic; });
    var out = '';
    shown.forEach(function (p, i) {
      if (i === 0) { out += card(p, { big: true }); if (shown.length > 1) out += '<div class="bzl-grid">'; }
      else { out += card(p); if (i === shown.length - 1) out += '</div>'; }
    });
    list.innerHTML = out;
  }

  function renderArticle(posts, id) {
    var p = posts.filter(function (x) { return String(x.id) === String(id); })[0] || posts[0];
    if (!p) return;
    var label = tagLabel(p.tag);
    var prods = (p.products || []).map(function (pr) {
      return '<li class="bzl-pr"><span class="bzl-pr__th"></span><span>' +
        '<a class="bzl-pr__name" href="' + esc(pr.url || catalogUrl) + '">' + esc(pr.title) + '</a>' +
        (pr.note ? '<small class="bzl-pr__note">' + esc(pr.note) + '</small>' : '') + '</span></li>';
    }).join('');
    /* "Czytaj dalej": same topic first, then the newest (the sample list is newest first) */
    var others = posts.filter(function (x) { return x.id !== p.id; });
    var next = others.filter(function (x) { return x.tag === p.tag; }).slice(0, 2);
    others.forEach(function (x) { if (next.length < 2 && next.indexOf(x) < 0) next.push(x); });

    var html =
      '<nav class="bzl-crumb" aria-label="' + esc(t('crumb_label')) + '"><a href="' + esc(listUrl('')) + '">' + esc(blogTitle) + '</a> / <a href="' + esc(listUrl(p.tag)) + '">' + label + '</a></nav>' +
      '<div class="bzl-meta"><span class="bzl-tag">' + label + '</span><span>' + reading(p.minutes) + (p.date ? ' · ' + esc(p.date) : '') + '</span></div>' +
      '<h1 class="bzl-display bzl-art__title">' + esc(p.title) + '</h1>' +
      (p.lead ? '<p class="bzl-lead">' + esc(p.lead) + '</p>' : '') +
      '<div class="bzl-art__img bzl-tone--' + esc(p.tag) + '">' + (p.image_label ? '<span class="bzl-ph" aria-hidden="true">' + esc(p.image_label) + '</span>' : '') + '</div>' +
      '<div class="bzl-cols">' +
        '<div class="bzl-body">' + (p.body || '') + '</div>' +
        '<aside class="bzl-aside">' +
          '<div class="bzl-calc"><p class="bzl-eyebrow">' + t('calc_eyebrow') + '</p><p class="bzl-calc__title">' + t('calc_title') + '</p>' +
            '<p class="bzl-calc__text">' + t('calc_text') + '</p><a class="bzl-btn" href="' + esc(catalogUrl) + '">' + t('calc_cta') + ' <span aria-hidden="true">→</span></a></div>' +
          (prods ? '<div class="bzl-prods"><h2 class="bzl-eyebrow">' + t('desserts_title') + '</h2><ul class="bzl-prods__list" role="list">' + prods + '</ul></div>' : '') +
        '</aside>' +
      '</div>' +
      '<section class="bzl-cta" aria-labelledby="bzl-cta-title-sample"><div><h2 class="bzl-display bzl-h2" id="bzl-cta-title-sample">' + t('cta_title') + '</h2>' +
        '<p class="bzl-cta__text">' + t('cta_text') + '</p></div><a class="bzl-btn bzl-btn--ink" href="' + esc(catalogUrl + '#bk-quiz') + '">' + t('cta_button') + ' <span aria-hidden="true">→</span></a></section>' +
      (next.length ? '<section class="bzl-next" aria-labelledby="bzl-next-title-sample"><h2 class="bzl-eyebrow" id="bzl-next-title-sample">' + t('next_title') + '</h2>' +
        '<div class="bzl-grid bzl-grid--two">' + next.map(function (x) { return card(x, { level: 'h3' }); }).join('') + '</div></section>' : '');

    var art = part('article');
    if (!art) {
      /* on the list page: hide the list, show the sample article in its place */
      ['hero', 'chips', 'list', 'newsletter'].forEach(function (n) { var el = part(n); if (el) el.hidden = true; });
      art = document.createElement('article');
      art.className = 'bzl-wrap bzl-art';
      art.setAttribute('data-bzl-part', 'article');
      root.appendChild(art);
    }
    art.innerHTML = html;
  }

  var src = root.getAttribute('data-bzl-sample');
  if (!src) return;
  fetch(src, { credentials: 'same-origin' })
    .then(function (r) { if (!r.ok) throw new Error('sample ' + r.status); return r.json(); })
    .then(function (data) {
      var posts = (data && data.posts) || [];
      if (!posts.length) return;
      banner();
      if (view === 'article' || params.has('wpis')) renderArticle(posts, params.get('wpis') || posts[0].id);
      else renderList(posts);
    })
    .catch(function () { /* the real page stays as it is */ });
})();
